import {
  IconButton,
  TableCell,
  Typography,
  Select,
  MenuItem,
  Chip,
  Box,
} from '@mui/material'
import { User } from 'types'
import DeleteIcon from '@mui/icons-material/Delete'
import TeamSelectById from './TeamSelectById'
import { ncoTaskStatusOptions } from 'components/DataGrid/filterArrays'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
import { FC } from 'react'

const STATUS_OPTIONS = ['Not Started', 'In Progress', 'Not Applicable', 'Done'] as const

interface SeededRowsProps {
  row: {
    key?: string
    assigneeIds: string[]
    canEdit: boolean
    dependencies: string[]
    itemId: string
    name: string
    orderIndex: number
    role: string
    sectionIndex: number
    status: 'Not Started' | 'In Progress' | 'Done'
  }
  options: User[]
  updateStatus: (row: any, newStatus: string) => void
  updateAssignees: (row: any, newIds: string[]) => void
  onRemoveSeeded: (row: any) => void
}

const SeededRows: FC<SeededRowsProps> = ({ row, options, updateStatus, updateAssignees, onRemoveSeeded }) => {
  return (
    <>
      <TableCell>{row.orderIndex}</TableCell>
      <TableCell>{row.name}</TableCell>
      <TableCell>
        {row.dependencies?.map(d => (
          <Typography key={`${row?.key}-${d}`}>{d}</Typography>
        ))}
      </TableCell>
      <TableCell>{row.role || '—'}</TableCell>
      <TableCell>
        <TeamSelectById
          name="assigneeIds"
          value={row.assigneeIds ?? []} // <-- IDs
          options={options} // <-- user objects
          displayLabel="Assignee(s)"
          onChange={({ target }) => updateAssignees(row, target.value as string[])}
          disabled={!row.canEdit}
          sx={{ py: 0.5 }}
        />
      </TableCell>
      <TableCell>
        <Select
          size="small"
          fullWidth
          value={STATUS_OPTIONS.includes(row.status) ? row.status : 'Not Started'}
          onChange={e => updateStatus(row, String(e.target.value))}
          disabled={!row.canEdit}
          renderValue={selected => (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
              gap={1}
            >
              {selected ? (
                <Chip
                  size="small"
                  style={{
                    backgroundColor: ncoTaskStatusOptions.find(opt => opt.label === selected)?.color,
                    width: 14,
                    height: 14,
                    borderRadius: '50%',
                  }}
                />
              ) : null}
              <Typography variant="subtitle1" noWrap>
                {selected}
              </Typography>
            </Box>
          )}
        >
          {STATUS_OPTIONS.map(s => (
            <MenuItem key={s} value={s} sx={{ color: renderColorByString(s) }}>
              {s}
            </MenuItem>
          ))}
        </Select>
      </TableCell>
      <TableCell align="right">
        <IconButton size="small" color="error" onClick={() => onRemoveSeeded(row)}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </TableCell>
    </>
  )
}

export default SeededRows
